import { useEffect, useRef } from 'react';
import moment from 'moment';
import { useFormikContext } from 'formik';
import { DateAvailabilityOut } from '../../../../api';
import { DATE_FORMAT } from '../../../calendarWrapper/CalendarWrapper';
import { EditOrderFormValues } from '../EditOrderTypes';
// @ts-ignore
import { useEditOrder } from '../EditOrderContext';
import { NINE_AM } from './orderFormDefaults';

type OrderFormSyncProps = {
  isEditOrder: boolean;
  isEventOrCourse: boolean;
  isWaitlistItem: boolean;
  // A copied event or course order keeps its empty date until staff pick one.
  isClone?: boolean;
  hasParent: boolean;
  orderPageIdOfOrder?: string;
  availableDatesForEvents: DateAvailabilityOut[];
  onSubmitFailed?: () => void;
};

export const OrderFormSync = ({
  isEditOrder,
  isEventOrCourse,
  isWaitlistItem,
  isClone,
  hasParent,
  orderPageIdOfOrder,
  availableDatesForEvents,
  onSubmitFailed,
}: OrderFormSyncProps) => {
  const { values, setFieldValue, setValues, errors, submitCount } = useFormikContext<EditOrderFormValues>();
  // @ts-ignore
  const { editOrderState, setDate: setDateInState } = useEditOrder();

  useEffect(() => {
    if (submitCount === 0 || Object.keys(errors).length === 0) return;
    onSubmitFailed?.();
  }, [submitCount, errors]);

  // A copied order keeps the source's details until staff switch to a different page.
  const initialOrderPageId = useRef(editOrderState.orderPage.id);

  useEffect(() => {
    const keepsCopiedDetails = !!isClone && editOrderState.orderPage.id === initialOrderPageId.current;
    if (!isEditOrder && !keepsCopiedDetails) {
      void setFieldValue('custom_personal_details', {});
    }
    if (!isEventOrCourse && !isEditOrder) {
      void setFieldValue('privateOrderEndTimeSeconds', editOrderState.orderPage.duration + values.timeSeconds);
    }
    if (editOrderState.orderPage.id !== orderPageIdOfOrder && !keepsCopiedDetails) {
      void setFieldValue('resourceOptionId', '');
    }
  }, [editOrderState.orderPage.id]);

  useEffect(() => {
    if (!isEventOrCourse) {
      void setFieldValue('privateOrderEndTimeSeconds', Number(editOrderState.details.duration) + values.timeSeconds);
    }
  }, [editOrderState.details.duration]);

  useEffect(() => {
    if (!isEventOrCourse || isEditOrder || isWaitlistItem || isClone || hasParent) return;
    if (availableDatesForEvents.length === 0) return;

    const firstAvailable = availableDatesForEvents.find((x) => moment(x.date) >= moment());
    const newDate = firstAvailable ? moment(firstAvailable.date) : moment();
    const formattedDate = newDate.format(DATE_FORMAT);
    const selectedTime = availableDatesForEvents.find((x) => x.date === formattedDate)?.times[0].seconds ?? NINE_AM;

    void setValues((prev) => ({
      ...prev,
      date: formattedDate,
      timeSeconds: selectedTime,
    }));
    setDateInState(newDate);
  }, [availableDatesForEvents]);

  return null;
};
